import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import {
  getFormsList,
  deleteForms,
  updateFormStatus,
} from "../../../services/Users-services.js";
import { useGlobalState } from "../../../services/hostelConst.js";
import { getOrganizationLevel } from "../../../services/OrganisationServices/organizationLevel";
import React, { useEffect, useState } from "react";
import AddGroupForm from "../../FormComponents/AddGroups";
import { showErrorMessages } from "../../../services/utilityFunctions";
import { useNavigate } from "react-router-dom";
const AllFromsTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    triggerChildSidebar,
  } = useGlobalState();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    triggerChildSidebar(false);
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    setIsInitialized(true);

    return () => {};
  }, []);
  return !isInitialized ? (
    <div></div>
  ) : (
    <MasterTable
      getTableData={getFormsList}
        updateStatus={updateFormStatus}
      deleteRow={deleteForms}
      tab1={"Forms"}
      tab2={"Forms"}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
      AddForm={AddGroupForm}
    />
  );
};

export default AllFromsTable;


